<template>
    <customModal :containersm="true" @closeModal="closePopup">
        <template #title> Field Rule </template>
        <template #body>
           <div class="row">
                <div class="input-group">
                    <input 
                        accept=".xls,.xlsx" 
                        id="InPutFile" 
                        type="file" 
                        class="form-control my-2 my-lg-0"
                        @change="previewFiles" 
                    />
                    <span class="input-group-append">
                        <button
                            type="button" 
                            class="stdy_upload_btn mr-0 py-1" 
                            @click="uploadEditChecks()"
                            :disabled="showLoading">
                            <div class="d-flex align-items-center" v-if="showLoading">
                                <img class="loading-img" width="20" src="../../assets/img/loading.webp"
                                    alt="Wait while the document is added" />
                            </div>
                            <div v-else>{{ "Upload" }}</div>
                        </button>
                    </span>
                </div>
                <span class="errorClass" v-if="error">
                {{ $t("Please select a file.") }}
                </span>
            </div>
        </template>
    </customModal>
</template>
<script>
    import axios from "axios";
    import store from "@/store";
    import customModal from "../customModal/customModal.vue";

    export default {
        name: "uploadEditcheck",
        components: { customModal },

        emits: ['close-popup'],
        data(){
            return {
                showLoading: false,
                error: false,
                xlsFile: null,  
                head: {},
                baseurl: process.env.VUE_APP_Service_URL, 
            };
        },
        computed: {
    studyid() {
        return store.getters.getStudyId; 
    }
},
        mounted(){
            const idtoken = store.getters.getIdToken;
            this.head = {
                headers: {
                    Authorization: "Bearer " + idtoken,
                },
            };
        },
        methods: {
            closePopup() {
                this.$emit("close-popup");
            },
            async previewFiles(event) {
                this.xlsFile = event.target.files[0];
                this.error = false;
            },
            async uploadEditChecks(){
                const studyId = await store.getters.getStudyIs;
                if (!this.xlsFile) {
                    this.error = true;
                    return;
                }
                this.showLoading = true;
                try{
                    var formData = new FormData();
                    formData.append("File", this.xlsFile,this.xlsFile.name);
                    formData.append("StudyId", studyId);
                    const idtoken = store.getters.getIdToken;
                    const response = await axios.post(`${this.baseurl}/management/study/uploadrules`, formData, this.head);
                } catch (error) {
                    console.error("Error uploading file:", error);
                } finally {
                    this.showLoading = false;
                    this.closePopup();
                }
            },
        },
    }
</script>